module.exports = __webpack_public_path__ + "static/media/04_NTC-2000LSY.f83dfb04.png";